import { makeCustomIcon } from './utils';

export const tunedStatIcon = makeCustomIcon(
  'TunedStat',
  32,
  32,
  'M2,14.25 h28 v3.5 h-28zM2,10.5 l7,-7 l7,7 h-4.5 l-2.5,-2.5 l-2.5,2.5 zM30,21.5 l-7,7 l-7,-7 h4.5 l2.5,2.5 l2.5,-2.5 z',
);
